export default __webpack_public_path__ + "static/media/video_icon.ee5b9a0e.svg";